module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/sms-99d9ede6d8879df79ba4768c20c35bee.png";